import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

const END_POINT_GET_OTP =
  process.env.REACT_APP_END_POINT_GET_OTP_FOR_UPDATE_EMAIL;

export const getOTP_ForUpdateUserEmail = createAsyncThunk(
  "update/user/email",
  async (patchData, thunkAPI) => {
    try {
      const result = fetchInterceptors(END_POINT_GET_OTP, "POST", patchData);
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getOTP_ForUpdateUserEmailSlice = createSlice({
  name: "getOTP_ForUpdateUserEmailSlice",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: null,
  },
  reducers: {
    setDefault_Generate_OTP_EmailSate: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOTP_ForUpdateUserEmail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOTP_ForUpdateUserEmail.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(getOTP_ForUpdateUserEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_Generate_OTP_EmailSate } =
  getOTP_ForUpdateUserEmailSlice.actions;

export default getOTP_ForUpdateUserEmailSlice.reducer;
